import React from 'react';
import { PublicPageLayout } from '../components/PublicPageLayout';

export function NotFoundPage() {
  return (
    <PublicPageLayout title="Sorry, we couldn't find that page" />
  );
}
